import React from 'react';
import { memoize } from 'react-data-table-component';
import { Edit2, Trash2 } from 'react-feather';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

const twoLinesStyle = {
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'normal',
  width: '100%'
};

const twoLinesCell = (text, tooltipId) =>
  text ? (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id={tooltipId}>{text}</Tooltip>}
    >
      <div style={twoLinesStyle}>{text}</div>
    </OverlayTrigger>
  ) : null;

const columns = memoize(
  (
    clickHandler,
    canUpdate,
    canDestroy,
    fromEstablishmentForm,
    yearSelected = null
  ) => [
    {
      name: 'NOMBRE',
      selector: 'names'
    },
    {
      name: 'APELLIDO',
      selector: 'last_names',
      sortable: true
    },
    {
      name: 'ESTABLECIMIENTO',
      cell: item =>
        twoLinesCell(
          yearSelected
            ? item.establishment_by_year?.name
            : item.current_establishment?.name,
          `establishment-${item.id}`
        ),
      wrap: true
    },
    {
      name: 'CURSO',
      cell: item => item.grade_by_year?.name
    },
    {
      name: 'SECCIÓN',
      cell: item => item.section_by_year?.name,
      width: '100px'
    },
    {
      name: 'GENERO',
      selector: 'gender'
    },
    {
      name: 'DESCRIPCIÓN',
      cell: item => twoLinesCell(item.description, `description-${item.id}`),
      wrap: true
    },
    {
      name: 'ACTIVO',
      selector: 'active'
    },
    {
      cell: infoItem => (
        <div>
          {!fromEstablishmentForm && (
            <>
              {canUpdate && (
                <Button
                  variant="outline-primary"
                  size="sm"
                  className="mr-2"
                  onClick={() => clickHandler(infoItem, 'edit')}
                >
                  <Edit2 className="small-svg" />
                </Button>
              )}
              {canDestroy && (
                <Button
                  variant="outline-danger"
                  size="sm"
                  className="mr-2"
                  onClick={() => clickHandler(infoItem, 'remove')}
                >
                  <Trash2 className="small-svg" />
                </Button>
              )}
            </>
          )}
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true
    }
  ]
);

export default columns;
